import React, { useContext } from 'react'
import { Field, Form, Formik } from 'formik';
import ValidationError from '../Errors/ValidationError';
import { getImages } from '../Common/const';
import { VehicleContext } from '../Context/VehicleContext';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';

const InterestedInUsedGMC  = ({shareThought}) => {
    const {submitContactForm} = useContext(VehicleContext);
        
    const recaptchaRef = React.useRef();

    const navigate = useNavigate();
    
    return (
        <>
            <Formik
                // validationSchema={validationSchema}
                initialValues={{
                    first_name: '',
                    last_name: '',
                    email: '',
                    comment: '',
                }}
                onSubmit={async (values, { resetForm }) => {
                    console.log(values);
                    const token = await recaptchaRef.current.executeAsync();
                    recaptchaRef.current.reset(); // Reset after use
                    values = { ...values, token: token };
                    const data = await submitContactForm(values);
                    if (data.success) {
                        resetForm();
                        navigate("/thank-you");
                    } else
                        alert("There was a problem with your submission");
                }}
            >
                {({ values, setFieldValue, field, form }) => (
                    <Form className="custom-form schedule-appointment-form" autoComplete="off" name="contact-form">
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey="6Lf_fF8sAAAAAOJtVcUfUDNeLHqTqrPaWd27x9ej" // Replace with your actual site key
                                size="invisible"
                            /> 
                        <div className='row'>
                            <div className='col-12'>
                                <div className='form-group'>
                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <div className='cs-label'>First Name</div>
                                        <div className='cs-require'>* Required</div>
                                    </div>
                                    <Field
                                        type="text"
                                        name="first_name"
                                        className="form-control"
                                        required />
                                    <ValidationError name="first_name" />
                                </div>
                                <div className='form-group'>
                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <div className='cs-label'>Last Name</div>
                                        <div className='cs-require'>* Required</div>
                                    </div>
                                    <Field
                                        type="text"
                                        name="last_name"
                                        className="form-control"
                                        required />
                                    <ValidationError name="last_name" />
                                </div>
                                <div className='form-group'>
                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <div className='cs-label'>Email</div>
                                        <div className='cs-require'>* Required</div>
                                    </div>
                                    <Field
                                        type="text"
                                        name="email"
                                        className="form-control"
                                        required />
                                    <ValidationError name="email" />
                                </div>
                                <div className='form-group'>
                                    <div className='cs-label text-start mb-2'>{shareThought ? "Share Your Thoughts..." : "Comments"}</div>
                                    <Field
                                        type="text"
                                        name="comment"
                                        className="form-control h-218"
                                        component="textarea" />
                                    <ValidationError name="comment" />
                                </div>
                            </div>
                        </div>
                        <div className='row mt-3 justify-content-between about-action-flex wow fadeInUp' data-wow-delay="0.6s">
                            <div className='col-12 text-center'>
                                <button className='btn-theme lg-btn w-300'>Send</button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default InterestedInUsedGMC 